import {PageLayout, Filters, InvoicesAdvancedTable} from '~/components'
import {InvoicesPageHeader} from './page_header'
import {useAddOrganisationEnvironments} from './use_unpaid_invoice_data'
import {Invoice} from '@eitje/api'

export const UnpaidInvoices = () => {
	const invoices = Invoice.useDoIndex({filters: {overdue: true}}, {joins: ['billingInfos', 'organisations', 'environments']})
	const unpaidInvoices = invoices.whereNot({status: ['paid', 'disregard']})

	const items = useAddOrganisationEnvironments(unpaidInvoices)

	if (!items.length) return null

	return (
		<PageLayout
			name="unpaid_invoices"
			headers={[<InvoicesPageHeader key={0} />, <Filters key={1} />]}
			filterProps={{
				items,
				filters: [
					'invoiceNumber',
					{name: 'invoiceStatus', fixedFilter: 'excludePaid'},
					'invoiceDate',
					{name: 'organisation', fixedFilter: 'withUnpaidInvoices'},
					{name: 'billingInfo', fixedFilter: 'withUnpaidInvoices'},
					{name: 'environment', fixedFilter: 'withUnpaidInvoices'},
					'organisationStatus',
				],
			}}
		>
			<InvoicesAdvancedTable />
		</PageLayout>
	)
}
